module.exports = __webpack_public_path__ + "media/static/icons/icon-reef-122e9100115d0bf9bfc0534e1ec4b6c1.svg";